const NAV_LOGIN_ID = "tabLogin";
const NAV_REGISTRATION_ID = "tabRegistration";
const NAV_CLUBREGISTRATION_ID = "tabClubRegistration";
const NAV_COURSEBOOKING = "tabCourseBooking";
const NAV_HALLBOOKING = "tabHallBooking";
const NAV_MYBOOKINGS = "tabMyBookings";

const STEP_LOGIN = 0;
const STEP_BOOKING = 1;

const TYPE_COURSES = "courses";
const TYPE_HALLS = "halls";
const TYPE_BOOKINGS = "bookings";

const SORT_A_BEFORE_B = 1;
const SORT_B_BEFORE_A = -1;
const SORT_NOTHING = 0;

const SORT_COURSE_TITLE = "CourseTitle";
const SORT_COURSE_STARTDATE = "CourseStartDate";
const SORT_COURSE_ENDDATE = "CourseEndDate";
const SORT_COURSE_MEMBERS = "MemberNumber";
const SORT_COURSE_PRICE = "RegularPrice";

const SORT_HALL_TITLE = "Title";
const SORT_HALL_AREA = "Area";
const SORT_HALL_TOU = "TypesOfUse";
const SORT_HALL_RENT = "details.Rent.Amount";
const SORT_HALL_OPENINGHOURS = "details.OpeningHours";
const SORT_HALL_MINBOOKDUR = "details.MinimalBookingDuration";

const FILTER_COURSE_CANRESERVATE = "CanReservation";
const FILTER_COURSE_CLUBINTERNAL = "IsCourseClubOnly";
const FILTER_COURSE_BOOKED = "booked";
const FILTER_COURSE_RESERVED = "reserved";

const FILTER_HALL_CANBOOK = "CanBooking";
const FILTER_HALL_BOOKED = "booked";
const FILTER_HALL_RESERVED = "reserved";

const PAYMENTOPTION_DEFAULT = "Default";
const PAYMENTOPTION_PAYPAL = "Paypal";
const PAYMENTOPTION_KLARNA = "Klarna";

const PAYPAL_BUTTON_ID = "paypal-button-renderarea";
const KLARNA_BUTTON_ID = "klarna-button-renderarea";

const COOKIEKEY_LASTCLUBNUM = "LAST_CLUB_NUM";
const COOKIEKEY_DISPLAYMODE = "DISPLAYMODE";

const COOKIEVAL_DISPLAYMODE_LIGHT = "LIGHT";
const COOKIEVAL_DISPLAYMODE_DARK = "DARK";

// #region object keys
// "simple" oneliner to get all keys (non-recursive) from an object to copy and paste into code
// console.log("[" + String(Object.keys(ObjectYouNeedKeysFor).map((key) => { return '"' + key + '"' })).replace(str => str.substring(str.lastIndex(","))) + "]");
// i just didnt feel like writing the keys by hand :)
const COURSE_OBJECT_KEYS = [
  "ClubNumber",
  "ClubName",
  "CourseId",
  "CourseTitle",
  "CourseDesignation",
  "CourseStartDate",
  "CourseEndDate",
  "RegularPrice",
  "IsLimitedMember",
  "MaxMemberNumber",
  "MinMemberNumber",
  "MemberNumber",
  "ReservationNumber",
  "CourseImage",
  "IsCourseClubOnly",
  "CanShowCourseNonClubMembers",
  "IsClubMember",
  "CanReservation",
  "Distance",
  "booked",
  "reserved",
  "tags",
];

const HALL_OBJECT_KEYS = ["ClubNumber","ClubName","ClubAdressNumber","Id","Title","Area","TypesOfUse","Image","BookedDates","CanBooking","ClubInternal","Distance","booked","tags"]

// #endregion

export default {
  created() {
    /*
      i did some reading... and found the following in the "Change Detection Caveats" section:
         --> "Vue does not allow dynamically adding new root-level reactive properties to an already created instance[...]"
         src: https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
     
      exposing constants as properties inside data() like the following makes them reactive
     
      <script>
      export const SOME_CONSTANT = "some value";
     
      export default {
        data: () => {
          return {
            SOME_CONSTANT: SOME_CONSTANT,
          },
        },
      };
      </script>
     
      since constants cannot/should not be changed, it makes no sense to expose the constants there
     
      in this case i use this as an "advantage" and came over with the following solution:
     */
    this.NAV_LOGIN_ID = NAV_LOGIN_ID;
    this.NAV_REGISTRATION_ID = NAV_REGISTRATION_ID;
    this.NAV_CLUBREGISTRATION_ID = NAV_CLUBREGISTRATION_ID;
    this.NAV_COURSEBOOKING = NAV_COURSEBOOKING;
    this.NAV_HALLBOOKING = NAV_HALLBOOKING;
    this.NAV_MYBOOKINGS = NAV_MYBOOKINGS;

    this.STEP_LOGIN = STEP_LOGIN;
    this.STEP_BOOKING = STEP_BOOKING;

    this.TYPE_COURSES = TYPE_COURSES;
    this.TYPE_HALLS = TYPE_HALLS;
    this.TYPE_BOOKINGS = TYPE_BOOKINGS;

    this.SORT_A_BEFORE_B = SORT_A_BEFORE_B;
    this.SORT_B_BEFORE_A = SORT_B_BEFORE_A;
    this.SORT_NOTHING = SORT_NOTHING;

    this.SORT_COURSE_TITLE = SORT_COURSE_TITLE;
    this.SORT_COURSE_STARTDATE = SORT_COURSE_STARTDATE;
    this.SORT_COURSE_ENDDATE = SORT_COURSE_ENDDATE;
    this.SORT_COURSE_MEMBERS = SORT_COURSE_MEMBERS;
    this.SORT_COURSE_PRICE = SORT_COURSE_PRICE;

    this.SORT_HALL_TITLE = SORT_HALL_TITLE;
    this.SORT_HALL_AREA = SORT_HALL_AREA;
    this.SORT_HALL_TOU = SORT_HALL_TOU;
    this.SORT_HALL_RENT = SORT_HALL_RENT;
    this.SORT_HALL_OPENINGHOURS = SORT_HALL_OPENINGHOURS;
    this.SORT_HALL_MINBOOKDUR = SORT_HALL_MINBOOKDUR;

    this.FILTER_COURSE_CANRESERVATE = FILTER_COURSE_CANRESERVATE;
    this.FILTER_COURSE_CLUBINTERNAL = FILTER_COURSE_CLUBINTERNAL;
    this.FILTER_COURSE_BOOKED = FILTER_COURSE_BOOKED;
    this.FILTER_COURSE_RESERVED = FILTER_COURSE_RESERVED;

    this.FILTER_HALL_CANBOOK = FILTER_HALL_CANBOOK;
    this.FILTER_HALL_BOOKED = FILTER_HALL_BOOKED;
    this.FILTER_HALL_RESERVED = FILTER_HALL_RESERVED;

    this.PAYMENTOPTION_DEFAULT = PAYMENTOPTION_DEFAULT;
    this.PAYMENTOPTION_PAYPAL = PAYMENTOPTION_PAYPAL;
    this.PAYMENTOPTION_KLARNA = PAYMENTOPTION_KLARNA;

    this.PAYPAL_BUTTON_ID = PAYPAL_BUTTON_ID;
    this.KLARNA_BUTTON_ID = KLARNA_BUTTON_ID;

    this.COURSE_OBJECT_KEYS = COURSE_OBJECT_KEYS;
    this.HALL_OBJECT_KEYS = HALL_OBJECT_KEYS;


    this.COOKIEKEY_LASTCLUBNUM = COOKIEKEY_LASTCLUBNUM;
    this.COOKIEKEY_DISPLAYMODE = COOKIEKEY_DISPLAYMODE;

    this.COOKIEVAL_DISPLAYMODE_DARK = COOKIEVAL_DISPLAYMODE_DARK;
    this.COOKIEVAL_DISPLAYMODE_LIGHT = COOKIEVAL_DISPLAYMODE_LIGHT;

    
    // the constants declared at the start of the file are added "dynamically" to the Vue object and are therefore non-reactive
  },
};
